import { Component, NgModule, Type } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthGuardGuest } from './guard/auth.guard-guest';
import { HomeWhiteLabelWiseComponent } from './home-white-label-wise/home-white-label-wise.component';
import { HomeComponent } from './home/home.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { LoginPage1Component } from './login-page1/login-page1.component';
import { LoginComponent } from './login/login.component';
import { HomeFreeplayComponent } from './home-freeplay/home-freeplay.component';
import { HelpFreeplayComponent } from './help-freeplay/help-freeplay.component';

const routes: Routes = [
  {
    path: "home",
    component: getHomeComponent(),
    canActivate: [AuthGuardGuest],
  },
  {
    path: "login",
    // component: LoginPageComponent
    component: LoginPage1Component
  },
  {
    path: "signup",
    // component: LoginPageComponent
    component: LoginPage1Component
  },
  {
    path: "help",
    component: HelpFreeplayComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }


export function getHomeComponent(): Type<Component> {

  if (environment.host.newHomePage == 'home-white-label') {
    return <Type<Component>>HomeWhiteLabelWiseComponent;
  } else if (environment.host.newHomePage == 'home-freeplay') {
    return <Type<Component>>HomeFreeplayComponent;
  } else {
    return <Type<Component>>HomeComponent;
  }


}